import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles, minResolution } from 'util/helpers';
import i18n from 'i18n';
import { Field } from 'react-final-form';
import SelectField from 'components/common/SelectField';
import ConfirmDialog from './ConfirmDialog';
import icCheckOnPC1x from 'assets/images/PC/@1x/ic_check_on.png';
import icCheckOnPC2x from 'assets/images/PC/@2x/ic_check_on@2x.png';
import icCheckOnSP2x from 'assets/images/SP/@2x/ic_check_on@2x.png';
import icCheckOnSP3x from 'assets/images/SP/@3x/ic_check_on@3x.png';
import icCheckOffPC1x from 'assets/images/PC/@1x/ic_check_off.png';
import icCheckOffPC2x from 'assets/images/PC/@2x/ic_check_off@2x.png';
import icCheckOffSP2x from 'assets/images/SP/@2x/ic_check_off@2x.png';
import icCheckOffSP3x from 'assets/images/SP/@3x/ic_check_off@3x.png';

const isChecked = ({ formValues }) => formValues.referringOrderInfo.checked;

class ReferredOrderSelect extends React.Component {
  constructor(props) {
    super(props);
    this.confirmCheckDialogRef = React.createRef();
    this.confirmUncheckDialogRef = React.createRef();
  }

  handleClickCheck() {
    const { formValues } = this.props;
    formValues.referringOrderInfo.checked
      ? this.confirmUncheckDialogRef.current.open()
      : this.confirmCheckDialogRef.current.open();
  }

  handleClickConfirmCheck() {
    const {
      index,
      updateOrder,
      updateReferringOrders,
      name,
      change,
      formValues
    } = this.props;
    change(name + '.checked', true);
    updateOrder(+formValues.referringOrderInfo.targetIndex);
    if (updateReferringOrders) {
      updateReferringOrders(index - 1);
    }
  }

  handleClickConfirmUncheck() {
    const {
      index,
      updateOrder,
      name,
      change,
      releaseReferringOrders
    } = this.props;
    change(name + '.checked', false);
    if (releaseReferringOrders) {
      releaseReferringOrders(index - 1);
    }
    updateOrder(null);
  }

  render() {
    const { className, name, options, formValues, updateOrder } = this.props;
    return (
      <div className={className}>
        <Field
          id={name + '.checked'}
          name={name + '.checked'}
          type="checkbox"
          render={({ input }) => (
            <React.Fragment>
              <input type="checkbox" {...input} hidden />
              <label
                className="checkbox-icon"
                htmlFor={name + '.checked'}
                onClick={() => this.handleClickCheck()}
              />
            </React.Fragment>
          )}
        />
        <SelectField
          name={name + '.targetIndex'}
          options={options}
          onChange={e => updateOrder(+e.target.value)}
          disabled={!formValues.referringOrderInfo.checked}
        />
        <span>
          {i18n.t('orderAggregators:common:order:referredOrderSelectLabel')}
        </span>
        <ConfirmDialog
          innerRef={this.confirmCheckDialogRef}
          title={i18n.t('orderAggregators:common:order.alertCheckCopyTitle')}
          message={i18n.t('orderAggregators:common:order.alertCheckCopy')}
          onSubmit={() => this.handleClickConfirmCheck()}
        />
        <ConfirmDialog
          innerRef={this.confirmUncheckDialogRef}
          title={i18n.t('orderAggregators:common:order.alertUncheckCopyTitle')}
          message={i18n.t('orderAggregators:common:order.alertUncheckCopy')}
          onSubmit={() => this.handleClickConfirmUncheck()}
        />
      </div>
    );
  }
}

const commonStyle = css`
  display: flex;
  align-items: center;

  .checkbox-icon {
    position: relative;
    display: inline-block;
    margin-right: 16px;
    cursor: pointer;

    &::after {
      position: absolute;
      top: 0;
      width: 28px;
      height: 28px;
      content: '';
    }
  }

  ${SelectField} {
    height: 28px;
    width: 108px !important;
  }

  span {
    display: inline-block;
    margin-left: 16px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .checkbox-icon {
    width: 28px;
    height: 28px;

    &::after {
      width: 28px;
      height: 28px;
      background-size: 28px;
      background-image: url('${props =>
        isChecked(props) ? icCheckOnPC1x : icCheckOffPC1x}');

      ${minResolution(2)`
        background-image: url('${props =>
          isChecked(props) ? icCheckOnPC2x : icCheckOffPC2x}');`}
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 -8px;

  .checkbox-icon {
    width: 32px;
    height: 32px;

    &::after {
      width: 32px;
      height: 32px;
      background-size: 32px;
      background-image: url('${props =>
        isChecked(props) ? icCheckOnSP2x : icCheckOffSP2x}');

      ${minResolution(3)`
        background-image: url('${props =>
          isChecked(props) ? icCheckOnSP3x : icCheckOffSP3x}');`}
    }
  }
`;

export default applyStyles(ReferredOrderSelect)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/ReferredOrderSelect.js